import { render, staticRenderFns } from "./menuBackgroundImage.vue?vue&type=template&id=2cf92c44&scoped=true"
import script from "./menuBackgroundImage.vue?vue&type=script&lang=js"
export * from "./menuBackgroundImage.vue?vue&type=script&lang=js"
import style0 from "./menuBackgroundImage.vue?vue&type=style&index=0&id=2cf92c44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf92c44",
  null
  
)

export default component.exports